import type { DocumentsAndRequestsFeatureConfig } from '../type';

export const documentsAndRequests: Partial<DocumentsAndRequestsFeatureConfig> = {
    overviewFilterText: true,
    overviewFilterProduct: true,
    overviewFilterProductType: true,
    overviewFilterCaseStatus: true,
    productDetailsMenuItem: true,
    signingAlwaysVisible: true,
};
